<main role="main u-m-t-20">
  <div class="row">
    <div class="columns">
      <div class="card spinner-section" [class.spinner-section--is-active]="vm?.validating || vm?.uploading">
        <div class="spinner-section__icon"></div>

        <!-- File Uploader -->
        <generic-bulk-upsert-file-uploader
          (fileSelected)="onFileSelected($event)"
          (validate)="onValidate()"
          (downloadTemplate)="onDownloadTemplate()"
        ></generic-bulk-upsert-file-uploader>

        <!-- Removed Items (preview during validation) -->
        <generic-removed-items-table
          *ngIf="vm?.validationResponse && !vm?.uploadResponse"
          [removed]="vm?.validationResponse?.removed || []"
        ></generic-removed-items-table>

        <!-- Validation Results Table (when errors exist) -->
        <generic-validation-table
          *ngIf="vm?.validationResponse && !vm?.uploadResponse"
          [records]="vm?.validationResponse?.records || []"
          [errors]="vm?.validationResponse?.errors || []"
          [changes]="vm?.validationResponse?.changes || []"
          [fields]="fields"
        ></generic-validation-table>

        <!-- Confirm Upload Button (when validation succeeds with no errors and there are changes) -->
        <div class="card__section" *ngIf="vm?.validationResponse && !vm?.validationResponse?.hasErrors && !vm?.uploadResponse && (vm?.validationResponse?.changes.length > 0 || vm?.validationResponse?.removed.length > 0)">
          <div class="row">
            <div class="columns">
              <button class="btn btn--primary" (click)="onShowConfirmModal()">
                <i class="fa fa-upload" aria-hidden="true"></i> Confirm {{ title }} Bulk Upload
              </button>
            </div>
          </div>
        </div>

        <!-- Upload Summary Table (after successful upload) -->
        <generic-upload-summary-table
          *ngIf="vm?.uploadResponse"
          [records]="vm?.uploadResponse?.records || []"
          [changes]="vm?.uploadResponse?.changes || []"
          [fields]="fields"
        ></generic-upload-summary-table>

        <!-- Removed Items (post-upload summary) -->
        <generic-removed-items-table
          *ngIf="vm?.uploadResponse"
          [removed]="vm?.uploadResponse?.removed || []"
        ></generic-removed-items-table>

        <!-- Reset Button -->
        <div class="card__section" *ngIf="vm?.uploadResponse">
          <div class="row">
            <div class="columns">
              <button class="btn btn--hollow" (click)="onReset()">
                <i class="fa fa-undo" aria-hidden="true"></i> Upload Another File
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Confirmation Modal -->
<opus-modal
  [visible]="showConfirmModal"
  [title]="'Confirm ' + title + ' Bulk Upload'"
  primaryLabel="Confirm Upload"
  secondaryLabel="Cancel"
  (action)="$event ? onConfirmUpload() : onCancelUpload()"
>
  <div class="row">
    <div class="columns">
      <p>No validation errors found. Are you sure you want to proceed with the {{ title }} Bulk Upload?</p>
      <p class="typography--caption">
        <strong>{{ vm?.validationResponse?.records?.length || 0 }}</strong> record(s) will be processed.
      </p>
      <p class="typography--caption" *ngIf="vm?.validationResponse?.removed?.length > 0">
        <strong>{{ vm?.validationResponse?.removed?.length }}</strong> existing rate package(s) will be <strong>deleted</strong> because they are not present in the uploaded file.
      </p>
    </div>
  </div>
</opus-modal>
